import React, { Component } from 'react';
import { H1, H3, H5, P, Subtitle, NextBtn, Highlights, Tag, Title} from '../css/fonts.js';
import { OuterContainer, ShContainer, WholeRow, OuterFlexBox} from '../css/container.js';
import { packedContent } from '../content.js';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Image from '../components/Image';
import { CgArrowLongRight } from "react-icons/cg";


class Packed extends Component {
  render() {
    return (
      <div>
      <OuterContainer>
        <ShContainer>
        <Navbar/>
        <br/><br/><br/><br/>
        <WholeRow>
          <img src={packedContent.logoimg} alt={packedContent.logoimg} style={{"width":"25%"}}/>
        </WholeRow>
        <WholeRow>
          <Subtitle theme={{color:"#FFD966"}}>Overview</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.overview }}/>
        <OuterFlexBox>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.role }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.team }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.time }}/>
        </OuterFlexBox>
        </WholeRow>
        <WholeRow>
          <Subtitle theme={{color:"#FFD966"}}>Problem</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.problem1 }}/>
          <H3 theme={{color:"#FFD966"}} dangerouslySetInnerHTML={{ __html: packedContent.problem2 }}/><br/>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.problem3 }}/>
        </WholeRow>
        <WholeRow>
          <Subtitle theme={{color:"#FFD966"}}>Solution</Subtitle>
          <Subtitle>Packed – Just you and your backpack.</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.solution }}/>
        <OuterFlexBox>
          <img src={packedContent.solutionimg1} alt={packedContent.solutionimg} style={{"width":"49%"}}/>
          <img src={packedContent.solutionimg2} alt={packedContent.solutionimg} style={{"width":"49%"}}/>
        </OuterFlexBox>
        {/**<br/><br/>
        <H5 dangerouslySetInnerHTML={{ __html: packedContent.value }}/>
        <Image src={packedContent.valueimg} alt={packedContent.valueimg} style={{"width":"100%"}}/>**/}
        </WholeRow>
        <WholeRow>
          <Title>Process</Title>
          <Subtitle theme={{color:"#FFD966"}}>Research activities throughout the design process</Subtitle>
          <img src={packedContent.processimg} alt={packedContent.processimg} style={{"width":"100%"}}/>
        </WholeRow>

        <WholeRow>
          <Title>Generative Research</Title>
        <OuterFlexBox>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.gr_goal }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.gr_method }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.gr_p }}/>
        </OuterFlexBox>
        </WholeRow>
        <div>
        <Subtitle theme={{color:"#FFD966"}}>Semi-structured Interview</Subtitle>
        <H5 dangerouslySetInnerHTML={{ __html: packedContent.gr }}/>
        </div>
        <Image src={packedContent.grimg} alt={packedContent.grimg} style={{"width":"100%"}}/>
        <WholeRow>
          <Subtitle theme={{color:"#FFD966"}}>Actionable Insights</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.insight1 }}/>
          <H3 theme={{color:"#FFD966"}} dangerouslySetInnerHTML={{ __html: packedContent.insight2 }}/>
        </WholeRow>
        <WholeRow>
          <Title>Ideation</Title>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.brainstorm }}/>
          <Image src={packedContent.brainstormimg} alt={packedContent.brainstormimg} style={{"width":"100%"}}/>
        </WholeRow>
        <WholeRow>
          <Title>Narrow Down</Title>
        </WholeRow>
        <div>
          <Subtitle theme={{color:"#FFD966"}}>Concept Testing</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.ct }}/>
        </div>
        <Image src={packedContent.ctimg} alt={packedContent.ctimg} style={{"width":"100%"}}/>
        <WholeRow>
          <Subtitle theme={{color:"#FFD966"}}>Deliverables</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.deliverables }}/>
          <OuterFlexBox>
            <img src={packedContent.personaimg1} alt={packedContent.packed_persona1} style={{"width":"49%"}}/>
            <img src={packedContent.personaimg2} alt={packedContent.packed_persona2} style={{"width":"49%"}}/>
          </OuterFlexBox><br/>
          <Image src={packedContent.journeymap} alt={packedContent.journeymap} style={{"width":"100%"}}/>
          </WholeRow>
          <br/>
        <WholeRow>
          <Title>Evaluation - Experience Prototype</Title>

        <OuterFlexBox>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.ut_goal }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.ut_method }}/>
          <H5 light theme={{widthM:"30%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.ut_p }}/>
        </OuterFlexBox>
        </WholeRow>
        <div>
        <Subtitle theme={{color:"#FFD966"}}>Materials</Subtitle>
        <H5 dangerouslySetInnerHTML={{ __html: packedContent.ut_materials }}/>
        </div>
        <Image src={packedContent.xpimg} alt={packedContent.xpimg} style={{"width":"100%"}}/>

        <WholeRow>
          <Subtitle theme={{color:"#FFD966"}}>Metrics</Subtitle>
        <OuterFlexBox>
          <H5 light theme={{widthM:"46%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.metrics1 }}/>
          <H5 light theme={{widthM:"46%", widthS: "100%"}} dangerouslySetInnerHTML={{ __html: packedContent.metrics2 }}/>
        </OuterFlexBox>
        </WholeRow>
        <WholeRow>
        <Subtitle theme={{color:"#FFD966"}}>Findings</Subtitle>
        <H3 theme={{color:"#FFD966"}} dangerouslySetInnerHTML={{ __html: packedContent.findings }}/>
        </WholeRow>
        <WholeRow>
          <Title>Learnings</Title>
          <Subtitle theme={{color:"#FFD966"}}>Communicate for conflict resolution</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.learning1 }}/>
          <Subtitle theme={{color:"#FFD966"}}>Improve user testing context</Subtitle>
          <H5 dangerouslySetInnerHTML={{ __html: packedContent.learning2 }}/>
        </WholeRow>
        <br/><br/>
        <WholeRow><Footer/></WholeRow>
          <NextBtn theme={{color:"#FFD966", shadow: "rgba(255, 217, 102, 0.5)"}} to={packedContent.link}>
            <CgArrowLongRight/>
          </NextBtn>
      </ShContainer>

      </OuterContainer>
      </div>
    );
  }
}

export default Packed;
